import styled from 'styled-components';
import Lottie from 'lottie-react';
import {device} from 'styled/device';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 20px;
  height: auto;
`;

export const Text = styled.div`
  margin: 0 auto 48px;
  text-align: center;
  max-width: 430px;
  font-size: 14px;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontSecondary : '#152946'};

  @media (min-width: ${device.tablet}) {
    font-size: 16px;
  }
`;

export const BottomBlock = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 48px;
  width: 100%;
`;

export const StyledLottieIVDocumentsAnimations = styled(Lottie)`
  width: 300px;
  margin: 0 auto 32px;
  height: 225px;
`;
